/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";[_nghost-%COMP%]{position:absolute;top:0;left:0}.draggable-mirror-container[_ngcontent-%COMP%]{pointer-events:none}.svg-preview-item-container[_ngcontent-%COMP%]{position:absolute}.app-mirror-enter[_ngcontent-%COMP%]{fill-opacity:.8}.app-mirror-outside[_ngcontent-%COMP%]{fill-opacity:1;opacity:1;cursor:pointer!important}"];
export { styles as styles };
